module.exports = __webpack_public_path__ + "static/img/Road freight picture.ad0c93a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/Road freight picture.png
// module id = SS2a
// module chunks = 44